import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { CommonUtility } from '@app/_modules/commonUtility';
import { CategoryService } from '@app/_services/category.service';
import { SweetAlertService } from '@app/_services/sweet-alert.service';

@Component({
  selector: 'app-mbenz-fee-details',
  templateUrl: './mbenz-fee-details.component.html',
  styleUrls: ['./mbenz-fee-details.component.less'],
})
export class MbenzFeeDetailsComponent implements OnInit {
  conName = new FormControl('');
  vehnum = new FormControl('');
  emailFormControl = new FormControl('');
  borname = new FormControl('');
  mobile = new FormControl('');
  customerId = new FormControl('');
  invoiceName = new FormControl('');
  invoiceAmount = new FormControl('');
  inr = new FormControl('');
  regVehicle = new FormControl('');
  regMob = new FormControl('');
  name = new FormControl('');
  amountPayable = new FormControl('');
  form: FormGroup;
  form1: FormGroup;
  form2: FormGroup;
  JSON: any;
  isgPay_url: string;
  todayDate: Date;
  @ViewChild('txnForm') txnForm: any;
  tranxnForm: FormGroup;
  loading = false;
  commonUtility: CommonUtility;
  showInputField = false;
  showInputField1 = false;
  showInputField2 = false;
  showTable: Boolean = false;
  totalDisabled: boolean = true;
  verified: boolean = false;
  isVerificationPending: boolean = true;
  isVerified: boolean = false;
  studentData: any;
  contractNos: any;
  Data: any;
  resStatusCode: any;
  submitted = false;
  showFields: boolean = false;
  contractNumbers: string[] = [];
  emailId: string;
  mobileNo: string;
  firstName: string;
  lastName: string;
  contractNumber: string;
  vehicleNumber: string;
  mobileNumber: string;
  checkboxValue: boolean = false;
  formSubmitted: boolean = false;
  EncDataField: string;
  MerchantIdField: string;
  TransactionId: string;
  BankIdField: string;
  TerminalIdField: string;
  VersionField: string;
  customerDetailsFetched: boolean = false;
  errorMessage: string = '';
  errorFlag: boolean = false;
  isOptionSelected: boolean = false;
  selectedOption: string = '';
  isVehicleNumberValid: boolean = false;
  customerDetails: null;

  constructor(
    private categoryService: CategoryService,
    private fb: FormBuilder,
    private sweetalert: SweetAlertService
  ) {
    this.isgPay_url = categoryService.isgPay_url;
    this.commonUtility = this.categoryService.commonUtility;

    this.form = this.fb.group({
      selectType: [''],
      conName: [''],
      regVehicle: [''],
      regMob: [''],
      selectedMobileNo: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.todayDate = new Date();
    this.tranxnForm = this.fb.group({
      Version: [''],
      TerminalId: [''],
      BankId: [''],
      MerchantId: [''],
      EncData: [''],
      TransactionId: [''],
      emailId: [''],
      mobileNo: [''],
      firstName: [''],
      lastName: [''],
    });

    this.form = this.fb.group({
      selectType: [''],
      conName: [''],
      regVehicle: [''],
      regMob: ['', [Validators.required, Validators.pattern('[1-9][0-9]{9}$')]],
      selectedContractNo: [''],
    });

    this.form1 = this.fb.group({
      payeeMobileNo: ['', [Validators.required, Validators.pattern('[1-9][0-9]{9}$')]],
      paymentInfo: ['', Validators.required],
      invoiceAmount: [''],
      name: ['', [Validators.required, Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)]],
      amountPayable: ['', [Validators.required, Validators.pattern(/^\d+\.?\d{0,2}$/)]],
    });
    this.invoiceAmount = this.form1.controls['invoiceAmount'] as FormControl;

    this.form1.get('paymentInfo')?.valueChanges.subscribe((value) => {
      if (value === 'Self') {
        this.form1.get('name')?.clearValidators();
        this.form1.get('name')?.reset();
      } else {
        this.form1.get('name')?.setValidators([Validators.required]);
      }
      this.form1.get('name')?.updateValueAndValidity();
    });

    // Add max value validator based on actual amount
    this.form1.get('invoiceAmount')?.valueChanges.subscribe((actualAmount) => {
      const maxAmount = parseFloat(actualAmount || '0');
      this.form1.get('amountPayable')?.setValidators([Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.max(maxAmount),]);
      this.form1.get('amountPayable')?.updateValueAndValidity();
    });
  }

  get f() {
    return this.form.controls;
  }

  onKeypress(event: KeyboardEvent) {
    const currentValue = this.form1.get('name')?.value || '';

    // Prevent if already at max length
    if (currentValue.length >= 30) {
      event.preventDefault();
      return;
    }

    // Allow letters A-Z, a-z, and space
    const charCode = event.key.charCodeAt(0);
    const isLetter = (charCode >= 65 && charCode <= 90) ||  // A-Z
      (charCode >= 97 && charCode <= 122);    // a-z
    const isSpace = event.key === ' ';  // Check for space key

    if (!isLetter && !isSpace) {
      event.preventDefault();
    }
  }

  numericOnly(event: KeyboardEvent): boolean {
    const charCode = event.key.charCodeAt(0);

    // Allow numbers (0-9)
    if (charCode >= 48 && charCode <= 57) return true;

    // Allow decimal point (.) but only once
    if (event.key === '.' && !event.currentTarget?.['value'].includes('.')) return true;

    // Allow control characters
    if ([8, 9, 13, 37, 39, 46].includes(event.keyCode)) return true; // backspace, tab, enter, arrows, delete

    event.preventDefault();
    return false;
  }

  validateVehicleNumber(value: string) {
    // Convert to uppercase and remove spaces and special characters
    const formattedValue = (value?.toUpperCase().replace(/[^A-Z0-9]/g, '') || '').slice(0, 15);
    this.vehicleNumber = formattedValue;

    // Validate the pattern (7-15 alphanumeric characters, no special characters)
    const pattern = /^[A-Z0-9]{7,15}$/;
    this.isVehicleNumberValid = pattern.test(formattedValue);

    if (this.handleInputChange) {
      this.handleInputChange('VehicleNumber', formattedValue);
    }

    // Return the sanitized value to update the input field
    return formattedValue;
  }

  sanitizeNumericInput(event: any, field: string): void {
    const input = event.target as HTMLInputElement;
    // Remove all non-numeric characters and limit to 8 digits
    const value = input.value.replace(/[^0-9]/g, '').slice(0, 8);

    // Update both the input value and FormControl
    input.value = value;
    this.conName.setValue(value, { emitEvent: false });

    // Trigger the input change handler
    this.handleInputChange('ContractNumber', value);
  }

  allowAlphanumericOnly(event: KeyboardEvent): boolean {
    const pattern = /^[A-Z0-9a-z]+$/;
    const inputChar = event.key;

    // If the input doesn't match the pattern, prevent it
    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }


  onOptionChange(selectedOption: string) {
    this.errorFlag = false;
    this.conName.setValue('');
    this.regVehicle.setValue('');
    this.regMob.setValue('');
    this.form.reset();
    this.customerDetailsFetched = false;
    this.isOptionSelected = !!selectedOption;
    this.selectedOption = selectedOption; // Store the currently selected option

    this.showInputField = false;
    this.showInputField1 = false;
    this.showInputField2 = false;

    this.contractNumber = '';
    this.vehicleNumber = '';
    this.mobileNumber = '';

    if (selectedOption === 'ContractNumber') {
      this.showInputField = true;
    } else if (selectedOption === 'VehicleNumber') {
      this.showInputField1 = true;
    } else if (selectedOption === 'MobileNumber') {
      this.showInputField2 = true;
    }
  }

  // Add this getter to determine if the form is valid
  get isFormValid(): boolean {
    if (!this.isOptionSelected) return false;

    switch (this.selectedOption) {
      case 'ContractNumber':
        return !!this.conName.value?.trim();
      case 'VehicleNumber':
        return !!this.isVehicleNumberValid;
      case 'MobileNumber':
        return (
          !!this.regMob.value?.trim() &&
          !!this.form.get('selectedContractNo')?.value
        );
      default:
        return false;
    }
  }

  // Function to handle input changes
  handleInputChange(field: string, value: string) {
    if (field === 'ContractNumber') {
      this.contractNumber = value;
    } else if (field === 'VehicleNumber') {
      console.log('in vehicle');
      this.vehicleNumber = value;
      console.log('in vehicle', this.vehicleNumber);
    } else if (field === 'MobileNumber') {
      this.mobileNumber = value;
    }
  }

  resetForm() {
    // Reset main form
    this.form.reset();

    // Reset form1 if applicable
    this.form1.reset();

    // Clear vehicle number and mobile number inputs
    //this.vehicleNumber = '';
    //this.regMob.setValue('');

    // Clear validation errors for regMob
    if (this.form.get('regMob')) {
      this.form.get('regMob').clearValidators();
      this.form.get('regMob').updateValueAndValidity();
    }

    // Clear fetched data
    this.contractNumbers = [];
    this.customerDetails = null;

    // Hide customer details section
    this.customerDetailsFetched = false;

    // Reset error flags and messages
    this.errorFlag = false;
    this.errorMessage = '';
  }

  validateAmountPayable() {
    const actualAmount = parseFloat(this.studentData.actualAmount || '0');
    const inputValue = this.form1.get('amountPayable')?.value;
    const amountPayable = parseFloat(inputValue);

    // Handle empty/invalid values
    if (isNaN(amountPayable) || amountPayable < 0) {
      this.commonUtility.alertMsg('Amount must be a positive number.', '', false);
      this.form1.get('amountPayable')?.setValue('');
      return;
    }

    // Format to 2 decimal places
    if (inputValue.split('.')[1]?.length > 2) {
      const formattedValue = amountPayable.toFixed(2);
      this.form1.get('amountPayable')?.setValue(formattedValue);
    }

    // Check against maximum amount
    if (amountPayable > actualAmount) {
      this.showAmountExceededSnackbar(actualAmount);
      this.form1.get('amountPayable')?.setValue('');
    }
  }

  showAmountExceededSnackbar(actualAmount: number) {
    this.commonUtility.alertMsg(`The actual amount is ${actualAmount}. Amount Payable greater than Actual Amount.`, '', false);
  }

  handleNumericInput(event: any) {
    // Remove any non-numeric characters
    let value = event.target.value.replace(/[^0-9]/g, '');

    // For mobile number fields, limit to 10 digits
    if (value.length > 10) {
      value = value.substr(0, 10);
    }

    // Update the input value
    event.target.value = value;

    // Update the form control value
    if (event.target.id === 'customInput2') {
      this.regMob.setValue(value);
    } else {
      this.form1.get('payeeMobileNo')?.setValue(value);
    }
  }

  handleNumericInput1(event: any) {
    // Remove any non-numeric characters
    let value = event.target.value.replace(/[^0-9]/g, '');

    // For mobile number fields, limit to 10 digits
    if (value.length > 10) {
      value = value.substr(0, 10);
    }

    // Update the input value
    event.target.value = value;

    // Update the form control value
    if (event.target.id === 'customInput2') {
      this.regMob.setValue(value);
    } else {
      this.form1.get('amountPayable')?.setValue(value);
    }
  }

  fetchByCustomerDetails() {
    let req = {};

    console.log('in if');
    if (this.showInputField) {
      req = {
        contractNo: this.contractNumber,
      };
    } else if (this.showInputField1) {
      req = {
        vehicleNo: this.vehicleNumber,
      };
    } else if (this.showInputField2) {
      req = {
        mobileNo: this.mobileNumber,
        contractNo: this.form.get('selectedContractNo').value,
      };
    }

    this.categoryService.fetchByCustomerDetails(req).subscribe(
      (res) => {
        console.log('req: ' + JSON.stringify(req));
        console.log('res: ' + JSON.stringify(res));

        if (res.body.statusCode === '99997') {
          this.commonUtility.alertMsg('Invalid Request', '', false);
          this.resStatusCode = null;
          this.studentData = null;
          this.customerDetailsFetched = false;
          this.verified = false;
        }

        // if (res.body.statusCode === '99998') {
        //   this.commonUtility.alertMsg('Something Went Wrong', '', false);
        //   this.resStatusCode = null;
        //   this.studentData = null;
        //   this.customerDetailsFetched = false;
        //   this.verified = false;
        // }

        if (res.body.statusCode === '10001') {
          this.commonUtility.alertMsg('No Data Available', '', false);
          this.resStatusCode = null;
          this.studentData = null;
          this.customerDetailsFetched = false;
          this.verified = false;
        }

        if (res.body.statusCode === '20030') {
          this.commonUtility.alertMsg('Payment Already Done', '', false);
          this.resStatusCode = null;
          this.studentData = null;
          this.customerDetailsFetched = false;
          this.verified = false;
        }

        if (res.body.statusCode === '20039') {
          this.commonUtility.alertMsg('Full Payment Already Done', '', false);
          this.resStatusCode = null;
          this.studentData = null;
          this.customerDetailsFetched = false;
          this.verified = false;
        }

        if (res.body.statusCode === '00000') {
          this.resStatusCode = res.body.statusCode;
          this.studentData = res.body.data.benzDetailsModel;
          console.log('benz model', this.studentData);
          this.customerDetailsFetched = true;
          this.conName.setValue(this.studentData.contractNo);
          this.vehnum.setValue(this.studentData.vehicleNo);
          this.mobile.setValue(this.studentData.mobileNo);
          this.borname.setValue(this.studentData.borrowerName);
          this.emailFormControl.setValue(this.studentData.emailId);
          this.invoiceAmount.setValue(this.studentData.actualAmount);
          this.verified = true;
        } else if (res.body.statusCode === '10001') {
          this.commonUtility.alertMsg('No Data Found', '', false);
        } else if (res.body.statusCode === '20040') {
          this.commonUtility.alertMsg(res.body.statusDesc, '', false);
          this.customerDetailsFetched = false;
        }
      },
      (error) => {
        this.commonUtility.alertMsg(error, '', false);
      }
    );

    this.showFields = true;
    this.isVerificationPending = false;
    this.isVerified = true;
  }

  fetchContractNobyMobileNo() {
    console.log('in API call');
    const selectedMobileNo = this.mobileNumber;

    if (!selectedMobileNo) {
      return;
    }

    const req = {
      mobileNo: selectedMobileNo,
    };

    this.categoryService.fetchContractNobyMobileNo(req).subscribe(
      (res) => {
        if (res.body.statusCode === '00000') {
          this.resStatusCode = res.body.statusCode;
          this.contractNumbers = res.body.data.contractNos;
          this.errorFlag = false;
        } else {
          this.contractNumbers = [];
          this.form.controls.selectedContractNo.markAsDirty();
          this.form.controls.selectedContractNo.setErrors({ incorrect: true });
          this.errorMessage =
            'No contract numbers found for the provided mobile number.'; // Set the message
          this.form.controls.selectedContractNo.markAsTouched();
          this.errorFlag = true;
          console.log(' this.errorMessage  ', this.errorMessage);
          console.warn(this.errorMessage);
          //this.form1.reset();
          this.customerDetailsFetched = false;
        }
      },
      (error) => {
        console.error('Error fetching contract numbers', error);
      }
    );
  }

  submitBenzDetails(): void {
    console.group('submitBenzDetails() Debugging');

    try {
      console.log('Initializing form submission...');
      this.submitted = true;
      this.loading = true;

      // Debug initial state
      console.log('Initial state:', {
        submitted: this.submitted,
        loading: this.loading,
        checkboxValue: this.checkboxValue,
        formValid: this.form1.valid,
        studentData: this.studentData
      });

      // Validate checkbox
      if (!this.checkboxValue) {
        console.warn('Validation failed: Terms & Conditions not accepted');
        this.commonUtility.alertMsg('Please Accept Terms & Conditions', '', false);
        this.loading = false;
        return;
      }

      // Validate amount
      if (this.form1.controls.invoiceAmount.value == 0) {
        console.warn('Validation failed: Invoice amount is zero');
        this.commonUtility.alertMsg(
          'Payable Amount Should Not be Zero, Please Enter a valid Amount',
          '',
          false
        );
        this.loading = false;
        return;
      }

      // Validate form
      if (this.form1.invalid) {
        console.warn('Form validation failed');
        console.log('Form Validation Status:', this.form1.status);
        console.log('Form Errors:', this.form1.errors);

        // Log each control's state
        Object.keys(this.form1.controls).forEach((key) => {
          const control = this.form1.controls[key];
          console.log(
            `Control: ${key}, ` +
            `Valid: ${control.valid}, ` +
            `Touched: ${control.touched}, ` +
            `Dirty: ${control.dirty}, ` +
            `Value:`,
            control.value,
            `Errors:`,
            control.errors
          );
        });

        this.form1.markAllAsTouched();
        this.loading = false;
        return;
      }

      // Prepare request payload
      let req: any;
      if (this.form1.value.name) {
        req = {
          contractNo: this.studentData.contractNo,
          vehicleNo: this.studentData.vehicleNo,
          mobileNo: this.studentData.mobileNo,
          borrowerName: this.studentData.borrowerName,
          payeeMobileNo: this.form1.controls.payeeMobileNo.value.toString(),
          emailId: this.studentData.emailId,
          actualAmount: this.studentData.actualAmount,
          amountPayable: this.form1.value.amountPayable,
          paymentInfo: this.form1.controls.paymentInfo.value.toString(),
          name: this.form1.value.name,
          source: 'BENZ',
        };
        console.log('Request with name:', req);
      } else {
        req = {
          contractNo: this.studentData.contractNo,
          vehicleNo: this.studentData.vehicleNo,
          mobileNo: this.studentData.mobileNo,
          borrowerName: this.studentData.borrowerName,
          payeeMobileNo: this.form1.controls.payeeMobileNo.value.toString(),
          emailId: this.studentData.emailId,
          actualAmount: this.studentData.actualAmount,
          amountPayable: this.form1.value.amountPayable,
          paymentInfo: this.form1.controls.paymentInfo.value.toString(),
          source: 'BENZ',
        };
        console.log('Request without name:', req);
      }

      console.log('Final request payload:', JSON.stringify(req, null, 2));

      // Make API call
      console.log('Making API call to submitBenzDetails...');
      this.categoryService.submitBenzDetails(req).subscribe(
        (res) => {
          console.log('API Response:', res);

          if (res.body?.statusCode === '00000') {
            console.log('Success response received');

            // Debug payment gateway fields
            const fields = res.body.data?.fields;
            console.log('Payment gateway fields:', fields);

            if (fields) {
              // Set form values
              this.tranxnForm.controls.EncData.setValue(fields.EncData);
              this.tranxnForm.controls.MerchantId.setValue(fields.MerchantId);
              this.tranxnForm.controls.BankId.setValue(fields.BankId);
              this.tranxnForm.controls.TerminalId.setValue(fields.TerminalId);
              this.tranxnForm.controls.Version.setValue(fields.Version);
              this.tranxnForm.controls.TransactionId.setValue(fields.TransactionId);
              this.tranxnForm.controls.emailId.setValue(fields.emailId);
              this.tranxnForm.controls.mobileNo.setValue(fields.mobileNo);
              this.tranxnForm.controls.firstName.setValue(fields.firstName);
              this.tranxnForm.controls.lastName.setValue(fields.lastName);

              // Store fields
              this.EncDataField = fields.EncData;
              this.MerchantIdField = fields.MerchantId;
              this.BankIdField = fields.BankId;
              this.TerminalIdField = fields.TerminalId;
              this.VersionField = fields.Version;

              console.log('Submitting transaction form...');
              this.txnForm.nativeElement.submit();
            } else {
              console.error('Missing fields in response');
              this.commonUtility.alertMsg('Invalid response format', '', false);
            }
          } else {
            console.error('API Error:', res.body?.statusDesc || 'Unknown error');
            this.commonUtility.alertMsg(
              res.body?.statusDesc || 'Payment processing failed',
              '',
              false
            );
          }

          this.loading = false;
        },
        (error) => {
          console.error('API Call Failed:', {
            status: error.status,
            statusText: error.statusText,
            url: error.url,
            error: error.error
          });

          this.commonUtility.alertMsg(
            error.statusText || 'Payment processing failed',
            '',
            false
          );
          this.loading = false;
        }
      );
    } catch (error) {
      console.error('Unexpected error in submitBenzDetails:', error);
      this.commonUtility.alertMsg('An unexpected error occurred', '', false);
      this.loading = false;
    } finally {
      console.groupEnd();
    }
  }

  openTermsAndConditionsPopup(event: Event) {
    event.preventDefault();
    this.sweetalert.errorAlert(
      'Terms & Conditions',
      `
<html>
<div style="font-size: 16px; text-align: left; max-height: 70vh; overflow-y: auto;">
    <p style="margin-bottom: 15px;">These terms and conditions apply to the Customer who uses this Online Payment Services for repayment of default EMI to Mercedes-Benz Financial Services India Private Limited (MBFSI). Kindly read these terms and conditions carefully. By authorizing a payment to MBFSI through this online payment service ("the service"), it would be treated as a deemed acceptance to these terms and conditions. MBFSI reserves all the rights to amend these terms and conditions at any time without giving prior notice. It is the responsibility of the Customer to read the terms and conditions before using the Service.</p>
    
    <h2 style="margin: 20px 0 10px; border-bottom: 1px solid #eee; padding-bottom: 5px;">Key Terms:</h2>
    <p style="margin-bottom: 10px;">The following is a summary of the key terms of this service:</p>
    <p style="margin-bottom: 10px;">Payment(s) through this Service may only be made with a RuPay Debit Card, Net-Banking, UPI (Unified Payments Interface) & UPI QR Code. Payments through Credit Card are not allowed.</p>
    <p style="margin-bottom: 10px;">Before using this Service, it is recommended that the Customer shall review the charges or fees payable against such transaction for use of RuPay Debit card/ Net Banking/UPI & UPI QR Code and verify the amount payable to MBFSI.</p>
    <p style="margin-bottom: 10px;">The RuPay Debit card/Net Banking/UPI & UPI QR Code information supplied by the customer at the time of using the service is processed by the payment gateway service provider alone and no information in this regard is shared with MBFSI. It is the sole responsibility of the Customer to ensure that the information entered in the relevant fields are correct. It is recommended that you take and retain a copy of the Transaction Acknowledgement for future records, which might assist in resolution of any disputes that may arise on usage of this service.</p>
    <p style="margin-bottom: 10px;">The Customer agrees, understands and confirms that his/ her personal data including without limitation details relating to RuPay Debit card/Net Banking/UPI / UPI QR Code transmitted over the Internet Payment Gateway may be susceptible to misuse, hacking, theft and/ or fraud and that MBFSI or the Payment Service Provider(s) have no control over such matters.</p>
    <p style="margin-bottom: 10px;">The service is provided using a payment gateway service provider through a secure website. However, neither the payment gateway service provider nor MBFSI gives any assurance, that the information so provided online by the Customer is secured or may be read or intercepted by a third party. MBFSI does not accept or assume any liability in the event of such unauthorized interception, hacking or other unauthorized access to information provided by a customer for usage of this service.</p>
    <p style="margin-bottom: 10px;">MBFSI and/or the Payment Service Providers shall not be liable for any inaccuracy, error or delay in, or omission of (a) any data, information or message, or (b) the transmission or delivery of any such data, information or message; or (c) any loss or damage arising from or occasioned by any such inaccuracy, error, delay or omission, non-performance or interruption in any such data, information or message. Under no circumstances shall MBFSI and/or the Payment Service Providers, its employees, directors, and its third party agents involved in processing, delivering or managing the Services, be liable for any direct, indirect, incidental, special or consequential damages, or any damages whatsoever, including punitive or exemplary arising out of or in any way connected with the provision of or any inadequacy or deficiency in the provision of the Services or resulting from unauthorized access or alteration of transmissions of data or arising from suspension or termination of the Service.</p>
    <p style="margin-bottom: 20px;">The Customer agrees that MBFSI or any of its employees will not be held liable for any loss or damages arising from the usage of Internet Payment Gateway services, or reliance upon the information contained on the Website, or any failure to comply with these Terms and Conditions where such failure is due to circumstance beyond MBFSI’s reasonable control.</p>

    <h2 style="margin: 20px 0 10px; border-bottom: 1px solid #eee; padding-bottom: 5px;">Privacy Policy:</h2>
    <p style="margin-bottom: 10px;">The information provided by the user related to payments RuPay Debit card/Net Banking/UPI /UPI QR Code are not accessed or stored by MBFSI in this website.</p>
    <p style="margin-bottom: 10px;">If payment is made by means of a card that you do not personally own, the permission of the card owner must always be obtained to make payments using the card and for any such payment, you are hereby requested to provide Third Party Declaration along with self-attested PAN card copy for the payee to our MBFSI customer service team. By using the system, you confirm that you have the permission for usage of the card and shall be providing the declaration.</p>
    <p style="margin-bottom: 10px;">Payment history details for a period of 1 (One) year from the date of transaction shall be available in the portal.</p>
    <p style="margin-bottom: 10px;"><strong>No Warranty:</strong> The information and materials contained in this site including, graphics, links or other items is provided on "As Is basis" basis by MBFSI and the payment gateway service provider which tries to provide information accurately and expressly disclaims liability for error or omission in this information and the materials. No representation or warranty of any kind either express or implied, statutory or otherwise with respect to usage of this payment gateway is given by MBFSI or the payment gateway service provider.</p>
    <p style="margin-bottom: 20px;"><strong>Limitation of Liability:</strong> In no event, MBFSI will be liable for any damage direct or indirect losses or expenses arising in connection with usage of the service or inability to use by any person delay of operation or transaction, computer virus etc.</p>
    <p style="margin-bottom: 20px;">The Customer authorizes MBFSI to exchange, share, part with all information related to the details and transaction history of the Customers to its Affiliates / Subsidiaries / banks / financial institutions / credit bureaus / agencies/participation in any telecommunication or electronic clearing network as may be required by law, customary practice, credit reporting, statistical analysis and credit scoring, verification or risk management and shall not hold MBFSI liable for use or disclosure of this information.</p>

    <h2 style="margin: 20px 0 10px; border-bottom: 1px solid #eee; padding-bottom: 5px;">Security:</h2>
    <p style="margin-bottom: 20px;">All payment details which are entered through this Payment Gateway are encrypted. The site is secure and uses 128-bit encryption to offer secure communications by encrypting all data to and from the site. MBFSI shall not be liable in case of any failure by the customer to properly protect data from being seen on their screen by other persons or otherwise obtained by such other persons, during the Online Payment process or in respect of any omission to provide accurate information in the Course of the Online Payment Process.</p>
    
    <h2 style="margin: 20px 0 10px; border-bottom: 1px solid #eee; padding-bottom: 5px;">Non – Binding</h2>
    <p style="margin-bottom: 20px;">Please note that this privacy policy does not create any contractual or other legal rights in or on behalf of any party, nor is it intended to do so.</p>

    <h2 style="margin: 20px 0 10px; border-bottom: 1px solid #eee; padding-bottom: 5px;">Prohibited Actions</h2>
    <p style="margin-bottom: 10px;">While using this Site, you agree not to, by any means (including hacking, cracking or defacing any portion of the Site) indulge in illegal or unauthorized activities including the following:</p>
    <ul style="margin-left: 20px; list-style-type: disc;">
      <li style="margin-bottom: 5px;">Restrict or inhibit any authorized user from using this Site</li>
      <li style="margin-bottom: 5px;">Use the Site for unlawful purposes</li>
      <li style="margin-bottom: 5px;">Harvest or collect information about Site users without their express consent</li>
      <li style="margin-bottom: 5px;">"Frame" or "mirror" any part of the Site without our prior authorization</li>
      <li style="margin-bottom: 5px;">Engage in spamming or flooding</li>
      <li style="margin-bottom: 5px;">Transmit any software or other materials that contain any virus, time bomb, or other harmful or disruptive component</li>
      <li style="margin-bottom: 5px;">Remove any copyright, trademark or other proprietary rights notices contained in the Site</li>
      <li style="margin-bottom: 5px;">Use any device, application or process to retrieve, index, "data mine" or in any way reproduce or circumvent the navigational structure or presentation of the Site</li>
    </ul>

    <h2 style="margin: 20px 0 10px; border-bottom: 1px solid #eee; padding-bottom: 5px;">Transaction Charges</h2>
    <table style="width: 100%; border-collapse: collapse; margin: 15px 0;">
      <tr style="background-color: #f8f9fa;">
        <th style="padding: 10px; border: 1px solid #dee2e6;">Mode of Payment</th>
        <th style="padding: 10px; border: 1px solid #dee2e6;">Charges</th>
      </tr>
      <tr>
        <td style="padding: 10px; border: 1px solid #dee2e6;">Debit Card - RuPay (Domestic)</td>
        <td style="padding: 10px; border: 1px solid #dee2e6;">NIL</td>
      </tr>
      <tr>
        <td style="padding: 10px; border: 1px solid #dee2e6;">UPI / UPI QR</td>
        <td style="padding: 10px; border: 1px solid #dee2e6;">NIL</td>
      </tr>
      <tr>
        <td style="padding: 10px; border: 1px solid #dee2e6;">Net Banking - All Flat Fee Banks</td>
        <td style="padding: 10px; border: 1px solid #dee2e6;">INR 30 + GST @ 18% per transaction<br>(or) as applicable from time-to-time</td>
      </tr>
    </table>

    <h2 style="margin: 20px 0 10px; border-bottom: 1px solid #eee; padding-bottom: 5px;">Refund Process</h2>
    <p style="margin-bottom: 20px;">In case of any refund, you are requested to send a mail to MBFSI customer service team and post verification the team would reach out to you on the same.</p>

    <h2 style="margin: 20px 0 10px; border-bottom: 1px solid #eee; padding-bottom: 5px;">Variations to the Terms and Conditions</h2>
    <p style="margin-bottom: 20px;">MBFSI reserves the right to vary these Terms and Conditions from time to time and the current version will be that published on this website. MBFSI may also make additions/deletions/alterations to the services offered, at its sole discretion. MBFSI reserves the right to withdraw the service at any time at its discretion and/ and retains the right to change the terms and conditions for Online Payments, without any prior notice.</p>
</div>
</html>
`,
      ''
    );
  }
}
